import moment from 'moment'

export const formatDateTime = (d: string): string => moment.utc(d, 'YYYY-MM-DD HH:mm').local().format('DD-MM-YYYY HH:mm');
export const formatDateTimeToLastSeen = (d: string): string => moment.utc(d).fromNow();

export const copyLocation = (currentLocation: string) => {
    const el = document.createElement('textarea');
    el.value = currentLocation;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    el.setSelectionRange(0, 9999999);
    document.execCommand('copy');
    document.body.removeChild(el);
}
